setEmailSignupPreviewGateVisible